import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useFetchContactQuery } from "../api";
import { ChatRoom } from "./chat-room";

type Props = {
	hotelID: string;
	contactID: string;
};

export const ContactChatRoom = ({ hotelID, contactID }: Props) => {
	const { data } = useFetchContactQuery({
		hotelID,
		contactID,
	});

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.CONTACT.TOP, { hotelID })} />;
	}

	return <ChatRoom hotelID={hotelID} contactID={contactID} data={data} />;
};

ContactChatRoom.displayName = "ContactChatRoom";
